import React, { useEffect } from 'react';
import { ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import { Button } from '@material-ui/core';
import './wsList.style.scss';
import { RoutePath } from 'data';
import { useHistory } from 'react-router';

const WorkspaceList: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const lang = props.lang.wsPanel.panel;
    const history = useHistory();
    const [keenRef, slider] = useKeenSlider<HTMLDivElement>({
        loop: false,
        rtl: true,
        slidesPerView: 2.2,
        spacing: 0,
        mode: 'free-snap',
    });

    useEffect(() => {
        slider?.resize();
    }, [keenRef]);

    return (
        <div className="d-flex">
            <div>
                <div className={`ucheck-kiosk-ws-list keen-slider`} ref={keenRef}>
                    {props.workspaces && props.workspaces.length ? (
                        <>
                            {props.workspaces.map((ws) => (
                                <div key={ws.id} className="keen-slider__slide">
                                    <div className="ws-card active">
                                        <h3>{ws.title}</h3>
                                        <h5>
                                            <span className="material-icons-outlined">description</span>
                                            {ws.forms.length + '  ' + lang.form}
                                        </h5>
                                        <Button onClick={() => history.push(RoutePath.dashboard.wsDetail(ws.id))}>
                                            {lang.entrance}
                                        </Button>
                                    </div>
                                </div>
                            ))}
                            {props.workspaces.length === 1 ? (
                                <>
                                    <div className="keen-slider__slide"></div>
                                    <div className="keen-slider__slide"></div>
                                </>
                            ) : null}
                        </>
                    ) : (
                        <p>{lang.emptyStateWS}</p>
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
    publishDetail: state.publishData,
    workspaces: state.workspacesData,
});

const connector = connect(mapStateToProps);
export default connector(WorkspaceList);
